export default {
  women: {
    en: 'Women',
  },
  men: {
    en: 'Men',
  },
  howItWorks: {
    en: 'How it works',
  },

  fathersDay: {
    en: 'Bamboo charcoal',
  },

  gift: {
    en: 'Gift',
  },
  gifts: {
    en: 'Gifts',
  },
  giftCard: {
    en: 'Gift card',
  },
  giftSubscription: {
    en: 'Gift subscription',
  },
  giftSetsWomen: {
    en: 'Gifts For Her',
  },
  giftSetsMen: {
    en: 'Gifts For Him',
  },
  skincareSets: {
    en: 'Skincare Sets',
  },
}
